export default "__VITE_ASSET__iiAmgYLB__"